import { connect } from 'react-redux';

import ClockManageDashboard from '../components/ClockManageDashboard';


const mapStateToProps = state => {
  const user = state.settings.user;
  return {
    user,
  };
};

const mapDispatchToProps = dispatch => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClockManageDashboard);
